import React from 'react';
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieConsent } from "./CookieConsent";

const Layout = ({ children, location }) => {
    return (
        <>
            <Header location={location} />
            <main className="">
                {children}
            </main>
            <Footer/>
            <CookieConsent />
        </>
    )
}

export { Layout };